/* Match my tile — the browser half. ONE source: served on the Worker test page (/t) and copied verbatim
   into the theme as assets/tile-match.js (scripts/sync-theme.mjs). No dependencies.

   Privacy by design: the photo is opened ON THE DEVICE and redrawn onto a canvas — that drops EXIF/GPS and
   every other byte of metadata — and only the customer's CROP (re-encoded JPEG, ≤ 1600 px) is uploaded.
   PDFs and (outside Safari) HEIC photos are converted by the Worker first (/v1/prepare: page 1 only,
   nothing stored), then cropped here the same way.

   Root: <div data-tile-match data-api="https://…workers.dev" data-sitekey="…" data-range="bath|tray|whirlpool"
              data-product="<handle>" data-privacy-url="/policies/privacy-policy"></div>          */
(function () {
  'use strict';
  var MAX_BYTES = 15 * 1024 * 1024, WORK_SIDE = 2000, CROP_SIDE = 1600;

  function ev(name, p) {
    p = p || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  function init(root) {
    if (root.__tm) return; root.__tm = 1;
    var API = (root.getAttribute('data-api') || '').replace(/\/$/, '');
    var SITEKEY = root.getAttribute('data-sitekey') || '';
    // Entry points pass ?range= (bath | tray | whirlpool) and ?product=<handle>; both are validated here and
    // again by the Worker.
    var qs = {}; try { var u = new URLSearchParams(location.search); qs.range = u.get('range'); qs.product = u.get('product'); } catch (e) {}
    var RANGE = /^(bath|tray|whirlpool)$/.test(qs.range || '') ? qs.range : (root.getAttribute('data-range') || 'bath');
    var PRODUCT = /^[a-z0-9][a-z0-9-]{1,118}[a-z0-9]$/.test(qs.product || '') ? qs.product : (root.getAttribute('data-product') || '');
    var PRIVACY = root.getAttribute('data-privacy-url') || '/policies/privacy-policy';
    var state = { work: null, box: null, matchId: null, kind: 'photo' };

    // ── Turnstile — it must NEVER dead-end (Mission Untouchable defect 10, 5 Oct 2026) ─────────
    // Normally invisible ('interaction-only'). A headless-WebKit run got "Please confirm you are not a
    // robot" with NO widget on screen; iPhones on Private Relay / Lockdown Mode / content blockers can hit
    // the same wall. So, three tiers:
    //   1. invisible check — fine for almost everyone;
    //   2. if it errors, times out or the Worker rejects the token → re-render the VISIBLE widget with
    //      "Tick the box to continue" (the pending match carries on as soon as it is ticked);
    //   3. if Turnstile can't load at all (blocked, unsupported) → say so and offer the email route.
    // The Worker still verifies every token server-side; nothing here is trusted.
    var TS_LOAD_MS = 10000, TS_INVISIBLE_MS = 8000, TS_WAIT_MS = 180000;
    var MAILTO = 'mailto:info@omnitub.co.uk?subject=' + encodeURIComponent('Match my tile');
    var tsPrompt = el('p', { class: 'tm-ts__prompt', role: 'status', 'aria-live': 'polite', hidden: '' });
    var tsWidget = el('div', { class: 'tm-ts__w' });
    var tsHelp = el('p', { class: 'tm-ts__help', hidden: '' }, [
      el('span', { class: 'tm-ts__why' }),
      'Email us a photo of your tile at ', el('a', { href: MAILTO, text: 'info@omnitub.co.uk' }), ' and we’ll match it.',
    ]);
    var tsBox = el('div', { class: 'tm-ts' }, [tsPrompt, tsWidget, tsHelp]);
    var tsId = null, tsToken = '', tsWaiters = [], tsMode = 'invisible';   // invisible | visible | failed
    function tsFlush(t) { var w = tsWaiters; tsWaiters = []; w.forEach(function (f) { f(t); }); }
    function tsReady(cb) {
      if (window.turnstile) return cb();
      if (!document.getElementById('tm-ts-js')) {
        window.__tmTsLoaded = function () { (window.__tmTsQ || []).forEach(function (f) { f(); }); window.__tmTsQ = []; };
        var s = el('script', { id: 'tm-ts-js', src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__tmTsLoaded', async: '', defer: '' });
        s.addEventListener('error', function () { (window.__tmTsF || []).forEach(function (f) { f(); }); });
        document.head.appendChild(s);
      }
      (window.__tmTsQ = window.__tmTsQ || []).push(cb);
      (window.__tmTsF = window.__tmTsF || []).push(function () { tsFail('blocked'); });
      setTimeout(function () { if (!window.turnstile) tsFail('timeout'); }, TS_LOAD_MS);
    }
    function tsMount(appearance) {
      try { if (tsId !== null && window.turnstile) window.turnstile.remove(tsId); } catch (e) {}
      tsId = null; tsWidget.innerHTML = '';
      try {
        tsId = window.turnstile.render(tsWidget, { sitekey: SITEKEY, action: 'tile_match', appearance: appearance, theme: 'light',
          callback: function (t) {
            tsToken = t;
            if (tsMode === 'visible') { tsPrompt.textContent = 'Thanks — carrying on.'; tsBox.classList.remove('tm-ts--ask'); }
            tsFlush(t);
          },
          'expired-callback': function () { tsToken = ''; },
          'timeout-callback': function () { tsToken = ''; if (tsMode === 'invisible') tsVisible(); },
          'error-callback': function () { tsToken = ''; if (tsMode === 'invisible') tsVisible(); else tsHelp.hidden = false; },
          'unsupported-callback': function () { tsFail('unsupported'); } });
      } catch (e) { tsFail('render'); }
    }
    function tsRender() {
      if (!SITEKEY || tsId !== null || tsMode === 'failed') return;
      tsReady(function () {
        if (tsId !== null || !window.turnstile) return;
        // Script arrived after we'd given up on it → offer the box rather than stay on the fallback.
        if (tsMode === 'failed') { tsMode = 'invisible'; tsVisible(); return; }
        tsMount(tsMode === 'visible' ? 'always' : 'interaction-only');
      });
    }
    // Tier 2: show the real checkbox + a clear instruction, and the email route underneath.
    function tsVisible(msg) {
      if (tsMode === 'failed') return;
      var first = tsMode !== 'visible';
      tsMode = 'visible';
      tsBox.classList.add('tm-ts--on', 'tm-ts--ask');
      tsPrompt.hidden = false; tsPrompt.textContent = msg || 'Tick the box to continue.';
      tsHelp.firstChild.textContent = 'Box not showing? ';
      tsHelp.hidden = false;
      // Deferred: this can run inside the invisible widget's own error callback.
      if (window.turnstile) setTimeout(function () { if (tsMode !== 'visible') return; if (first || tsId === null) tsMount('always'); else tsReset(); }, 0);
      if (first) ev('tile_match_turnstile', { mode: 'visible' });
      try { tsBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
    // Tier 3: Turnstile cannot run here at all — never leave a spinner or a riddle; give the email route.
    function tsFail(why) {
      if (tsMode === 'failed' || window.turnstile && why === 'timeout') return;
      tsMode = 'failed';
      try { if (tsId !== null && window.turnstile) window.turnstile.remove(tsId); } catch (e) {}
      tsId = null; tsWidget.innerHTML = '';
      tsBox.classList.add('tm-ts--on', 'tm-ts--fail'); tsBox.classList.remove('tm-ts--ask');
      tsPrompt.hidden = false; tsPrompt.textContent = 'Our photo check can’t run in this browser — it may be blocked by a privacy setting or content blocker.';
      tsHelp.firstChild.textContent = '';
      tsHelp.hidden = false;
      ev('tile_match_turnstile', { mode: 'failed', reason: why || '' });
      tsFlush('');
    }
    function botError() {
      // Short pointers — the full instruction (and the email link) sits in the box just below.
      var e = new Error(tsMode === 'failed'
        ? 'Our photo check can’t run here — you can email us your tile instead (see below).'
        : 'Nearly there — tick the box below.');
      e.tm = 'ts'; return e;
    }
    // A token for ONE request. Rejects (e.tm === 'ts') only when there is no way to get one.
    function token() {
      return new Promise(function (resolve, reject) {
        if (!SITEKEY) return resolve('');
        if (tsMode === 'failed') return reject(botError());
        tsRender();
        if (tsToken) { var t = tsToken; tsToken = ''; return resolve(t); }
        var done = false;
        function finish(t) { if (done) return; done = true; tsToken = ''; if (t) resolve(t); else reject(botError()); }
        tsWaiters.push(finish);
        if (tsMode === 'visible') { tsPrompt.textContent = 'Tick the box to continue.'; tsBox.classList.add('tm-ts--ask'); }
        setTimeout(function () { if (!done && tsMode === 'invisible') tsVisible(); }, TS_INVISIBLE_MS);
        setTimeout(function () { finish(''); }, TS_WAIT_MS);
      });
    }
    function tsReset() { try { if (tsId !== null && window.turnstile) window.turnstile.reset(tsId); } catch (e) {} }
    // The Worker refused the token (403 { turnstile: true }) → escalate to the visible box, never a dead end.
    function tsRejected(again) {
      if (tsMode === 'failed') return botError().message;
      tsVisible('Tick the box to continue, then ' + again + '.');
      return 'Nearly there — tick the box below.';
    }

    // ── UI ──────────────────────────────────────────────────────────────────────────────
    var status = el('p', { class: 'tm-status', role: 'status', 'aria-live': 'polite' });
    var input = el('input', { type: 'file', id: 'tm-file', class: 'tm-file', accept: 'image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif,application/pdf,.pdf' });
    var drop = el('label', { class: 'tm-drop', for: 'tm-file' }, [
      el('span', { class: 'tm-drop__icon', 'aria-hidden': 'true', text: '+' }),
      el('span', { class: 'tm-drop__t', text: 'Choose a photo of your tile' }),
      el('span', { class: 'tm-drop__s', text: 'JPG, PNG, HEIC or WebP photo, or a PDF — up to 15 MB. Take it straight on, in daylight, close enough to fill the frame.' }),
    ]);
    var stepUpload = el('div', { class: 'tm-step tm-step--upload' }, [input, drop]);

    var stage = el('div', { class: 'tm-stage' });
    var canvas = el('canvas', { class: 'tm-canvas', 'aria-label': 'Your photo' });
    var box = el('div', { class: 'tm-box', tabindex: '0', role: 'slider', 'aria-label': 'Crop box: drag over just the tile. Use arrow keys to move it, Shift and arrow keys to resize it.' });
    ['nw', 'ne', 'sw', 'se'].forEach(function (c) { box.appendChild(el('span', { class: 'tm-h tm-h--' + c, 'data-h': c })); });
    stage.appendChild(canvas); stage.appendChild(box);
    var btnMatch = el('button', { type: 'button', class: 'tm-btn tm-btn--primary', text: 'Match my tile' });
    var btnAgain = el('button', { type: 'button', class: 'tm-btn tm-btn--ghost', text: 'Choose a different photo' });
    var stepCrop = el('div', { class: 'tm-step tm-step--crop', hidden: '' }, [
      el('h3', { class: 'tm-h3', text: 'Drag the box over just the tile' }),
      el('p', { class: 'tm-p', text: 'Leave out grout, the bath, walls and floor if you can. If it is a room photo, pick the biggest clear area of tile.' }),
      stage, el('div', { class: 'tm-actions' }, [btnMatch, btnAgain]),
    ]);

    var res = el('div', { class: 'tm-step tm-step--result', hidden: '' });
    root.innerHTML = '';
    root.appendChild(stepUpload); root.appendChild(stepCrop); root.appendChild(res); root.appendChild(status); root.appendChild(tsBox);
    root.classList.add('tm-ready');
    tsRender();
    var mId = (function () { try { var v = new URLSearchParams(location.search).get('m') || ''; return /^[A-Za-z0-9]{22}$/.test(v) ? v : ''; } catch (e) { return ''; } })();
    var mColour = (function () { try { return new URLSearchParams(location.search).get('colour') || ''; } catch (e) { return ''; } })();
    if (mId) {
      fetch(API + '/v1/match/' + mId).then(function (r) { return r.json(); }).then(function (k) {
        if (!k.ok) { say(k.error || 'This match has expired — upload your tile again for a fresh match.', true); return; }
        res.innerHTML = '';
        var pick = k.recs[0];
        for (var i = 0; i < k.recs.length; i++) if (slug(k.recs[i].code) === mColour) pick = k.recs[i];
        var holder = el('div');
        var chips = el('div', { class: 'tm-chips', role: 'radiogroup', 'aria-label': 'Your four colours' });
        k.recs.forEach(function (r) {
          var b = el('button', { type: 'button', class: 'tm-chip', role: 'radio', 'aria-checked': r === pick ? 'true' : 'false' }, [
            el('span', { class: 'tm-chip__sw', style: 'background:' + (/^#[0-9A-F]{6}$/i.test(r.hex) ? r.hex : '#ccc') }),
            el('span', { class: 'tm-chip__txt' }, [el('b', { text: r.code }), ' ' + r.name, el('small', { text: r.tag })]),
          ]);
          b.addEventListener('click', function () { pick = r; [].forEach.call(chips.children, function (c) { c.setAttribute('aria-checked', c === b ? 'true' : 'false'); }); holder.innerHTML = ''; holder.appendChild(chooser(r)); });
          chips.appendChild(b);
        });
        var again2 = el('button', { type: 'button', class: 'tm-btn tm-btn--ghost', text: 'Match another tile' });
        again2.addEventListener('click', function () { show(stepUpload); try { root.scrollIntoView({ behavior: 'smooth' }); } catch (e) {} });
        res.appendChild(el('div', { class: 'tm-result tm-result--chips' }, [el('div', { class: 'tm-result__body' }, [
          el('p', { class: 'tm-eyebrow', text: 'Your four colours' }),
          el('p', { class: 'tm-p', text: 'Choose a colour, then the bath or tray you’re considering.' }), chips, el('div', { class: 'tm-actions' }, [again2]) ])]));
        holder.appendChild(chooser(pick));
        res.appendChild(holder);
        show(res);
        try { (location.hash === '#choose' ? holder : res).scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }).catch(function () { say('We couldn’t load your colours just now. Please try again.', true); });
    }

    function say(t, bad) { status.textContent = t || ''; status.classList.toggle('tm-status--bad', !!bad); }
    function busy(b, label) { btnMatch.disabled = b; btnMatch.textContent = b ? (label || 'Matching…') : 'Match my tile'; root.classList.toggle('tm-busy', b); }
    function show(step) { [stepUpload, stepCrop, res].forEach(function (s) { s.hidden = s !== step; }); }

    // ── the chooser: WHICH bath or tray to open in the Drawing Room (Omnitub, 2 Oct 2026) ─────────
    // Ranges + sizes come from the Drawing Room's own hub (Worker /v1/catalogue), so every option is a
    // product the Drawing Room really builds. The last choice is remembered on this device only.
    var STUDIO = 'https://www.omnitub.co.uk/apps/studio', LS = 'omn_tm_choice', CAT = null;
    function catalogue() {
      if (!CAT) { CAT = fetch(API + '/v1/catalogue').then(function (r) { return r.json(); }).then(function (j) { if (!j.ok) throw new Error('cat'); return j.ranges; }); CAT.catch(function () { CAT = null; }); }
      return CAT;
    }
    function recall() { try { var v = JSON.parse(localStorage.getItem(LS) || 'null'); return v && typeof v === 'object' ? v : null; } catch (e) { return null; } }
    function remember(o) { try { localStorage.setItem(LS, JSON.stringify(o)); } catch (e) {} }
    function slug(code) { return String(code).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function chooser(colour) {
      var box = el('div', { class: 'tm-choose', id: 'choose' });
      var classic = colour.system === 'RAL Classic';
      box.appendChild(el('h3', { class: 'tm-h3', text: 'What are you colour-matching?' }));
      box.appendChild(el('p', { class: 'tm-p', text: 'Pick the range, then the size — we’ll open it ' + (window.OMN_HIDE_DR ? 'ready to order' : 'in the Drawing Room') + ' in ' + colour.code + ' ' + colour.name + '. It opens in a new tab, so this page stays here.' }));
      var quick = el('div', { class: 'tm-quick' }), grid = el('div', { class: 'tm-ranges', role: 'list' }), sizes = el('div', { class: 'tm-sizes', hidden: '' });
      var note = classic ? null : el('p', { class: 'tm-p tm-note', text: 'Whirlpool baths come in RAL Classic colours. ' + colour.code + ' is from the RAL DESIGN SYSTEM plus range, so whirlpools are not listed for this colour — pick a RAL Classic suggestion to see them.' });
      box.appendChild(quick); box.appendChild(grid); if (note) box.appendChild(note); box.appendChild(sizes);
      var status2 = el('p', { class: 'tm-status', role: 'status', 'aria-live': 'polite', text: 'Loading the ranges…' });
      box.appendChild(status2);
      // Drawing Room hidden (Theme settings → Omnitub): open the product page instead — its buy box
      // reads ?colour= and preselects Custom colour in that RAL.
      var HIDE_DR = !!window.OMN_HIDE_DR;
      function href(h) { return HIDE_DR ? '/products/' + encodeURIComponent(h) + '?colour=' + slug(colour.code) : STUDIO + '?product=' + encodeURIComponent(h) + '&colour=' + slug(colour.code); }
      function productLink(it, range, badge) {
        var a = el('a', { class: 'tm-prod', href: href(it.h), target: '_blank', rel: 'noopener' }, [
          it.img ? el('img', { src: it.img, alt: '', loading: 'lazy', width: '96', height: '96' }) : el('span', { class: 'tm-prod__ph' }),
          el('span', { class: 'tm-prod__txt' }, [
            badge ? el('span', { class: 'tm-prod__badge', text: badge }) : null,
            el('span', { class: 'tm-prod__size', text: it.size || it.t }),
            it.size ? el('span', { class: 'tm-prod__t', text: it.t }) : null,
            it.from ? el('span', { class: 'tm-prod__from', text: 'From ' + it.from }) : null,
          ]),
          el('span', { class: 'tm-prod__go', 'aria-hidden': 'true', text: '→' }),
        ]);
        a.setAttribute('aria-label', 'Open the ' + (it.size || '') + ' ' + it.t + (HIDE_DR ? '' : ' in the Drawing Room') + ' in ' + colour.code + ' ' + colour.name + ' (opens in a new tab)');
        a.addEventListener('click', function () { remember({ range: range.key, h: it.h }); ev('tile_match_open_drawing_room', { ral: colour.code, product: it.h, range: range.key }); });
        return a;
      }
      catalogue().then(function (ranges) {
        status2.textContent = ''; status2.hidden = true;
        ranges = ranges.filter(function (r) { return classic || !r.classicOnly; });
        var find = function (h) { for (var i = 0; i < ranges.length; i++) for (var k = 0; k < ranges[i].items.length; k++) if (ranges[i].items[k].h === h) return { r: ranges[i], it: ranges[i].items[k] }; return null; };
        function openRange(list, label, focusH) {
          sizes.innerHTML = ''; grid.hidden = true; quick.hidden = true; if (note) note.hidden = true; sizes.hidden = false;
          var back = el('button', { type: 'button', class: 'tm-back', text: '← All ranges' });
          back.addEventListener('click', function () { sizes.hidden = true; grid.hidden = false; quick.hidden = false; if (note) note.hidden = false; try { grid.querySelector('button').focus(); } catch (e) {} });
          sizes.appendChild(back);
          sizes.appendChild(el('h4', { class: 'tm-h4', text: label }));
          list.forEach(function (grp) {
            if (grp.heading) sizes.appendChild(el('p', { class: 'tm-sizes__grp', text: grp.heading }));
            var ul = el('div', { class: 'tm-prods', role: 'list' });
            grp.items.forEach(function (it) { var a = productLink(it, grp.range, it.h === focusH ? 'Your last choice' : ''); a.setAttribute('role', 'listitem'); ul.appendChild(a); });
            sizes.appendChild(ul);
          });
          try { back.focus({ preventScroll: true }); sizes.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
        }
        ranges.forEach(function (r) {
          var b = el('button', { type: 'button', class: 'tm-range', role: 'listitem' }, [el('span', { class: 'tm-range__l', text: r.label }), el('span', { class: 'tm-range__s', text: r.sub + ' · ' + r.items.length + (r.items.length === 1 ? ' size' : ' sizes') })]);
          b.addEventListener('click', function () { remember({ range: r.key }); ev('tile_match_choose_range', { range: r.key, ral: colour.code }); openRange([{ range: r, items: r.items }], r.label); });
          grid.appendChild(b);
        });
        var all = el('button', { type: 'button', class: 'tm-range tm-range--all' }, [el('span', { class: 'tm-range__l', text: 'Not sure yet — show me all' }), el('span', { class: 'tm-range__s', text: 'Every bath and tray, by range and size' })]);
        all.addEventListener('click', function () { ev('tile_match_choose_range', { range: 'all', ral: colour.code }); openRange(ranges.map(function (r) { return { heading: r.label, range: r, items: r.items }; }), 'Every bath and tray'); });
        grid.appendChild(all);
        // Skip ahead: the product they came from, or the last thing they chose on this device.
        var mem = recall(), from = PRODUCT ? find(PRODUCT) : null, last = mem && mem.h ? find(mem.h) : null;
        var pin = from || last;
        if (pin) {
          quick.appendChild(el('p', { class: 'tm-quick__h', text: from ? 'The one you were looking at' : 'Your last choice' }));
          quick.appendChild(productLink(pin.it, pin.r, ''));
        }
        if (!from && mem && mem.range && !mem.h) {
          for (var i = 0; i < ranges.length; i++) if (ranges[i].key === mem.range) { openRange([{ range: ranges[i], items: ranges[i].items }], ranges[i].label); break; }
        }
      }).catch(function () {
        status2.textContent = '';
        status2.appendChild(el('span', { text: 'We couldn’t load the ranges just now. ' }));
        status2.appendChild(HIDE_DR ? el('a', { href: '/collections/deep-traditional-baths', text: 'Browse our baths' }) : el('a', { href: STUDIO + '?colour=' + slug(colour.code), target: '_blank', rel: 'noopener', text: 'Open the Drawing Room' }));
      });
      return box;
    }

    // ── 1. open the file on the device → canvas (strips metadata) ─────────────────────────
    function loadBitmap(blob) {
      if (window.createImageBitmap) return createImageBitmap(blob, { imageOrientation: 'from-image' }).catch(function () { return viaImg(blob); });
      return viaImg(blob);
    }
    function viaImg(blob) {
      return new Promise(function (ok, no) {
        var u = URL.createObjectURL(blob), i = new Image();
        i.onload = function () { URL.revokeObjectURL(u); ok(i); };
        i.onerror = function () { URL.revokeObjectURL(u); no(new Error('decode')); };
        i.src = u;
      });
    }
    function toWork(bmp) {
      var w = bmp.width, h = bmp.height, s = Math.min(1, WORK_SIDE / Math.max(w, h));
      var c = document.createElement('canvas'); c.width = Math.round(w * s); c.height = Math.round(h * s);
      var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(bmp, 0, 0, c.width, c.height);
      if (bmp.close) try { bmp.close(); } catch (e) {}
      return c;
    }
    function prepare(file) {
      say('Opening your file…');
      return token().then(function (t) {
        var fd = new FormData(); fd.append('file', file); fd.append('cf-turnstile-response', t);
        return fetch(API + '/v1/prepare', { method: 'POST', body: fd });
      }).then(function (r) { tsReset(); return r.json().then(function (j) { if (!r.ok || !j.ok) throw new Error(j.turnstile ? tsRejected('choose your file again') : (j.error || 'We couldn\'t open that file.')); return j; }); })
        .then(function (j) { state.kind = j.kind; return fetch(j.image).then(function (r) { return r.blob(); }); }).then(loadBitmap);
    }
    function onFile(file) {
      if (!file) return;
      say('');
      if (file.size > MAX_BYTES) { say('That file is over 15 MB. Please choose a smaller photo or PDF.', true); return; }
      var name = (file.name || '').toLowerCase(), type = (file.type || '').toLowerCase();
      var isPdf = type === 'application/pdf' || /\.pdf$/.test(name);
      var isHeic = /heic|heif/.test(type) || /\.(heic|heif)$/.test(name);
      state.kind = isPdf ? 'pdf' : isHeic ? 'heic' : 'photo';
      var p = isPdf ? prepare(file) : loadBitmap(file).catch(function () { if (isHeic) return prepare(file); throw new Error("We couldn't open that photo. Please try a JPG or PNG."); });
      p.then(function (bmp) {
        state.work = toWork(bmp);
        ev('tile_match_upload', { kind: state.kind, range: RANGE });
        startCrop();
      }).catch(function (e) { say(e.message || "We couldn't open that file.", true); input.value = ''; });
    }
    input.addEventListener('change', function () { onFile(input.files && input.files[0]); });
    ['dragover', 'dragenter'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('tm-drop--over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('tm-drop--over'); }); });
    drop.addEventListener('drop', function (e) { onFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });

    // ── 2. the crop box (in canvas pixels; drawn scaled) ───────────────────────────────────
    function startCrop() {
      var w = state.work.width, h = state.work.height;
      canvas.width = w; canvas.height = h; canvas.getContext('2d').drawImage(state.work, 0, 0);
      var bw = Math.round(w * 0.6), bh = Math.round(h * 0.6);
      state.box = { x: Math.round((w - bw) / 2), y: Math.round((h - bh) / 2), w: bw, h: bh };
      show(stepCrop); drawBox(); say('');
      setTimeout(function () { drawBox(); try { stepCrop.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }, 30);
    }
    function scale() { return canvas.getBoundingClientRect().width / canvas.width || 1; }
    function drawBox() {
      if (!state.box) return;
      var s = scale(), b = state.box;
      box.style.left = (b.x * s) + 'px'; box.style.top = (b.y * s) + 'px'; box.style.width = (b.w * s) + 'px'; box.style.height = (b.h * s) + 'px';
    }
    window.addEventListener('resize', drawBox);
    function clamp(b) {
      var W = canvas.width, H = canvas.height, min = Math.max(48, Math.round(Math.min(W, H) * 0.06));
      b.w = Math.max(min, Math.min(W, b.w)); b.h = Math.max(min, Math.min(H, b.h));
      b.x = Math.max(0, Math.min(W - b.w, b.x)); b.y = Math.max(0, Math.min(H - b.h, b.y));
      return b;
    }
    var drag = null;
    box.addEventListener('pointerdown', function (e) {
      e.preventDefault(); box.setPointerCapture && box.setPointerCapture(e.pointerId);
      drag = { h: e.target.getAttribute('data-h'), sx: e.clientX, sy: e.clientY, b: Object.assign({}, state.box) };
    });
    box.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var s = scale(), dx = (e.clientX - drag.sx) / s, dy = (e.clientY - drag.sy) / s, b = Object.assign({}, drag.b);
      if (!drag.h) { b.x += dx; b.y += dy; }
      else {
        if (/w/.test(drag.h)) { b.x += dx; b.w -= dx; } if (/e/.test(drag.h)) b.w += dx;
        if (/n/.test(drag.h)) { b.y += dy; b.h -= dy; } if (/s/.test(drag.h)) b.h += dy;
        if (b.w < 0 || b.h < 0) return;
      }
      state.box = clamp({ x: Math.round(b.x), y: Math.round(b.y), w: Math.round(b.w), h: Math.round(b.h) }); drawBox();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { box.addEventListener(t, function () { drag = null; }); });
    box.addEventListener('keydown', function (e) {
      var k = e.key, st = Math.max(4, Math.round(canvas.width / 60)), b = Object.assign({}, state.box);
      if (!/^Arrow/.test(k)) return; e.preventDefault();
      if (e.shiftKey) { if (k === 'ArrowLeft') b.w -= st; if (k === 'ArrowRight') b.w += st; if (k === 'ArrowUp') b.h -= st; if (k === 'ArrowDown') b.h += st; }
      else { if (k === 'ArrowLeft') b.x -= st; if (k === 'ArrowRight') b.x += st; if (k === 'ArrowUp') b.y -= st; if (k === 'ArrowDown') b.y += st; }
      state.box = clamp(b); drawBox();
    });
    btnAgain.addEventListener('click', function () { input.value = ''; state.work = null; show(stepUpload); say(''); });

    // ── 3. upload the crop only ─────────────────────────────────────────────────────────────
    function cropBlob() {
      var b = state.box, s = Math.min(1, CROP_SIDE / Math.max(b.w, b.h));
      var c = document.createElement('canvas'); c.width = Math.round(b.w * s); c.height = Math.round(b.h * s);
      c.getContext('2d').drawImage(state.work, b.x, b.y, b.w, b.h, 0, 0, c.width, c.height);
      return new Promise(function (ok) { c.toBlob(function (bl) { ok(bl); }, 'image/jpeg', 0.9); });
    }
    btnMatch.addEventListener('click', function () {
      busy(true); say('Checking your photo and matching the colours — this takes a few seconds…');
      Promise.all([cropBlob(), token()]).then(function (a) {
        var fd = new FormData();
        fd.append('image', a[0], 'tile.jpg'); fd.append('range', RANGE); if (PRODUCT) fd.append('product', PRODUCT);
        fd.append('cf-turnstile-response', a[1]);
        return fetch(API + '/v1/match', { method: 'POST', body: fd });
      }).then(function (r) { tsReset(); return r.json().then(function (j) { return { r: r, j: j }; }); })
        .then(function (x) {
          busy(false);
          if (!x.r.ok || !x.j.ok) {
            ev('tile_match_result', { outcome: 'rejected', reason: x.j.rejected || ('http_' + x.r.status), range: RANGE });
            say(x.j.turnstile ? tsRejected('press Match my tile again') : (x.j.error || 'Something went wrong. Please try again.'), true);
            if (x.j.rejected === 'crop') { try { box.focus(); } catch (e) {} }
            return;
          }
          state.matchId = x.j.id; say('');
          ev('tile_match_result', { outcome: 'match', ral: x.j.top.code, range: RANGE });
          renderResult(x.j);
        }).catch(function (e) { busy(false); say(e && e.tm === 'ts' ? e.message : "We couldn't reach the matcher just now. Please check your connection and try again.", true); });
    });

    // ── 4. result + "Email me all four colours" ─────────────────────────────────────────────
    function renderResult(j) {
      res.innerHTML = '';
      var name = el('input', { type: 'text', id: 'tm-name', name: 'name', autocomplete: 'name', maxlength: '80', required: '' });
      var email = el('input', { type: 'email', id: 'tm-email', name: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254', required: '' });
      var hp = el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off', class: 'tm-hp', 'aria-hidden': 'true' });
      var opt = el('input', { type: 'checkbox', id: 'tm-optin', name: 'marketing' });
      var send = el('button', { type: 'submit', class: 'tm-btn tm-btn--primary', text: 'Email me all four colours' });
      var fstat = el('p', { class: 'tm-status', role: 'status', 'aria-live': 'polite' });
      var form = el('form', { class: 'tm-form', novalidate: '' }, [
        el('h3', { class: 'tm-h3', text: 'Email me all four colours' }),
        el('p', { class: 'tm-p', text: "We'll send a PDF with all four RAL colours we'd suggest for this tile — the closest match, one for the lighter areas, one if the tile looks warmer in person, and a contrast — with what we see in it." }),
        el('div', { class: 'tm-fields' }, [
          el('div', { class: 'tm-field' }, [el('label', { for: 'tm-name', text: 'Your name' }), name]),
          el('div', { class: 'tm-field' }, [el('label', { for: 'tm-email', text: 'Your email' }), email]),
        ]),
        hp,
        el('div', { class: 'tm-check' }, [opt, el('label', { for: 'tm-optin', text: 'Yes, send me occasional news about new colours and offers from Omnitub. (Optional — unsubscribe at any time.)' })]),
        el('p', { class: 'tm-privacy' }, ['We use your name and email to send this PDF and, if we can help further, to follow up about your tile. We keep the cropped tile photo for 30 days, then delete it. ', el('a', { href: PRIVACY, text: 'Privacy policy' }), '.']),
        send, fstat,
      ]);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!name.value.trim()) { fstat.textContent = 'Please add your name.'; fstat.classList.add('tm-status--bad'); name.focus(); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { fstat.textContent = 'Please check your email address.'; fstat.classList.add('tm-status--bad'); email.focus(); return; }
        send.disabled = true; send.textContent = 'Sending…'; fstat.textContent = ''; fstat.classList.remove('tm-status--bad');
        token().then(function (t) {
          return fetch(API + '/v1/match/' + encodeURIComponent(state.matchId) + '/email', { method: 'POST', headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ name: name.value.trim(), email: email.value.trim(), marketing: opt.checked, website: hp.value, turnstile: t }) });
        }).then(function (r) { tsReset(); return r.json().then(function (k) { return { r: r, k: k }; }); }).then(function (x) {
          if (!x.r.ok || !x.k.ok) { send.disabled = false; send.textContent = 'Email me all four colours'; fstat.textContent = x.k.turnstile ? tsRejected('press Email me all four colours again') : (x.k.error || 'Something went wrong. Please try again.'); fstat.classList.add('tm-status--bad'); return; }
          ev('tile_match_email', { ral: j.top.code, range: RANGE, marketing_optin: opt.checked });
          form.innerHTML = '';
          form.appendChild(el('h3', { class: 'tm-h3', text: 'On its way' }));
          form.appendChild(el('p', { class: 'tm-p', text: 'Check your inbox for the PDF with all four colours. If it is not there in a few minutes, look in your spam folder or email info@omnitub.co.uk.' }));
        }).catch(function (e) { send.disabled = false; send.textContent = 'Email me all four colours'; fstat.textContent = e && e.tm === 'ts' ? e.message : "We couldn't send that just now. Please try again."; fstat.classList.add('tm-status--bad'); });
      });
      var again = el('button', { type: 'button', class: 'tm-btn tm-btn--ghost', text: 'Match another tile' });
      again.addEventListener('click', function () { input.value = ''; state.work = null; show(stepUpload); say(''); try { root.scrollIntoView({ behavior: 'smooth' }); } catch (e) {} });
      res.appendChild(el('div', { class: 'tm-result' }, [
        el('div', { class: 'tm-swatch', style: 'background:' + (/^#[0-9A-F]{6}$/i.test(j.top.hex) ? j.top.hex : '#ccc'), role: 'img', 'aria-label': 'Colour swatch: ' + j.top.code + ' ' + j.top.name }),
        el('div', { class: 'tm-result__body' }, [
          el('p', { class: 'tm-eyebrow', text: 'Your closest RAL' }),
          el('h3', { class: 'tm-result__code' }, [j.top.code + ' ', el('span', { text: j.top.name })]),
          el('p', { class: 'tm-p tm-why', text: j.why }),
          el('p', { class: 'tm-p tm-note', text: 'Screens and phone cameras shift colour, so treat the swatch as a guide: before you order, hold the RAL code against your tile in daylight using a physical RAL colour card.' }),
          el('div', { class: 'tm-actions' }, [again]),
        ]),
      ]));
      res.appendChild(chooser(j.top));
      res.appendChild(form);
      show(res);
      try { res.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }
  }

  function boot() { var r = document.querySelectorAll('[data-tile-match]'); for (var i = 0; i < r.length; i++) init(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
